import useGameTableInfo from '@/src/hooks/data/useGameTableInfo';
import styles from './GameTableIdentity.module.css';

const GameTableIdentity = ({ tempTableId }) => {
    const { tableId, gameId, lobbyTime, isTourney, tourneyId, smallBlind, bigBlind } = useGameTableInfo(tempTableId);

    return tableId || gameId || lobbyTime || isTourney || tourneyId ? (
        <div className={styles.gameInfoSection}>
            ({smallBlind}/{bigBlind}) {isTourney ? tourneyId + ' ' + new Date(lobbyTime)?.toLocaleTimeString() : tableId + ' ' + new Date(lobbyTime)?.toLocaleTimeString()}
        </div>
    ) : null;
}

export default GameTableIdentity;